import React from "react";
import styled, { css } from "styled-components";
import Modal from "../Modal";
import Button from "../Elements/Button";
import useCopy from "../../hooks/useCopy";

const variants = {
  default: {
    body: css`
      padding 50px 10px;
    `,
  },
  compact: {
    body: css`
      padding 10px;
    `,
  },
};
const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  button {
    margin: 0 5px;
  }
`;

const Body = styled.div`
  padding: 50px 10px;
  text-align: left;
  font-size: 17px;
  line-height: 1.3;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.default};
  ${({ variant }) => variant && variants[variant].body}
`;

export default function ConfirmationModal({
  title,
  onConfirm,
  onClose,
  onCancel,
  children,
  variant = "default",
}) {
  const [cancelText, confirmText] = useCopy([
    "global.cancel",
    "global.confirm",
  ]);

  const renderFooter = () => {
    return (
      <FooterWrapper>
        <Button
          variant="light"
          onClick={onCancel || onClose}
          id="confirmationModalCancel"
        >
          {cancelText}
        </Button>
        <Button onClick={onConfirm} id="confirmationModalConfirm">
          {confirmText}
        </Button>
      </FooterWrapper>
    );
  };

  return (
    <Modal
      title={title}
      footer={renderFooter()}
      close={onClose}
      variant="light"
    >
      <Body variant={variant}>{children}</Body>
    </Modal>
  );
}
